import { WithProductId } from '@mews-commander/types';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useProductQuery } from '../queries/useProductQuery';

export const useIsProductCentrallyManaged = ({ productId }: WithProductId) => {
    const product = useProductQuery({ productId });
    const isCentralProductsEditEnabled = useFeatureFlag(FeatureFlag.centralProductsEditEnabled);

    return !!product?.enterpriseProductId && isCentralProductsEditEnabled;
};
